import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './component/Login';
import Dashboard from './component/Dashboard';
import Home from './component/Home';
import Customer from './component/Customer';
import Material from './component/Material';
import History from './component/History';
import AddCustomer from './component/AddCustomer';
import AssignMaterial from './component/AssignMaterial';
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("mughalsLoggedIn");
    if (token) {
      setIsLoggedIn(true);
    }

    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); 

    return () => clearTimeout(timer);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem("token", token);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };
if (loading) {
  return (
    <div className="loader-container">
      <h1 className="wavy-text">
        {
          'MUGHAL BLASTING SERVICES'.split('').map((char, index) => (
            <span
              key={index}
              className="wave-letter"
              style={{
                animationDelay: `${index * 0.15}s`,
              }}
            >
              {char}
            </span>
          ))
        }
      </h1>
    </div>
  );
}




  return (

      <div className="App">
        <Routes>
          {!isLoggedIn ? (
            <>
              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          ) : (
            <>
            
              <Route path="/assignmaterial" element={<Dashboard onLogout={handleLogout}><AssignMaterial /></Dashboard>} />
              <Route path="/Home" element={<Dashboard onLogout={handleLogout}><Home /></Dashboard>} />
              <Route path="/Customer" element={<Dashboard onLogout={handleLogout}><Customer /></Dashboard>} />
              <Route path="/Material" element={<Dashboard onLogout={handleLogout}><Material /></Dashboard>} />
              <Route path="/History" element={<Dashboard onLogout={handleLogout}><History /></Dashboard>} />
              <Route path="/AddCustomer" element={<Dashboard onLogout={handleLogout}><AddCustomer /></Dashboard>} />
              <Route path="*" element={<Navigate to="/Home" />} />
            </>
          )}
        </Routes>
      </div>
  );
}

export default App;
